import { OCEANO } from "./oceano";
import { extendPreset } from "./types";

const SLATE = "#4A6572";

/**
 * "Espuma" preset: clean and minimal, flat surfaces and few effects
 */
export const ESPUMA = extendPreset(OCEANO, {
  id: "espuma",
  defaults: {
    source: SLATE,
    variant: "neutral",
  },
  preview: {
    background: "#F4F5F6",
    surface: "#FFFFFF",
    primary: SLATE,
    accent: "#9AA7AE",
  },
  accent: SLATE,
  surfaceChroma: 0,
  tracking: "-0.03em",
  radiusScale: 0.6,
  shadows: {
    "1": "none",
    "2": "0 1px 2px rgba(0, 0, 0, 0.12)",
    "3": "0 2px 6px rgba(0, 0, 0, 0.12)",
    "4": "0 4px 12px rgba(0, 0, 0, 0.14)",
  },
  gradients: {
    auth: "var(--typ-color-surface-container)",
  },
  components: {
    nav: {
      unread: "var(--typ-color-on-surface)",
      "header-bg": "var(--typ-color-surface-container-high)",
      "header-fg": "var(--typ-color-on-surface)",
      "badge-bg": "var(--typ-color-surface-container-highest)",
      "badge-fg": "var(--typ-color-on-surface)",
    },
    message: {
      "hover-bg": "rgba(var(--typ-rgb-on-surface), 0.04)",
      "mention-bg": "rgba(var(--typ-rgb-on-surface), 0.06)",
      "mention-bar": "var(--typ-color-on-surface)",
      "new-line": "var(--typ-color-outline)",
      "new-bg": "var(--typ-color-outline)",
      "new-fg": "var(--typ-color-surface)",
    },
    quote: {
      "nested-bg": "rgba(var(--typ-rgb-on-surface), 0.05)",
      "nested-bar": "var(--typ-color-outline)",
    },
    call: {
      speaking: "var(--typ-color-on-surface)",
    },
    dialog: {
      "scrim-blur": "none",
    },
  },
});
